<template>
  <base-input
    v-model.number="val"
    type="number"
    label="Määrä"
    hide-label
    :wrapper-class="[wrapperClass, 'number-field', !valueInRange && 'has-error']"
    class="text-center"
    v-bind="$attrs"
    :min="min"
    :max="max"
    :step="step"
    @focus="onFocus"
    @blur="onBlur"
  >
    <template v-if="!hideSpinners" #left>
      <button class="btn btn-tertiary h-full w-3em justify-center p-0" :disabled="!canDecrease" @click="decrease">
        <minus-icon size="1.5x" />
      </button>
    </template>
    <template v-if="!hideSpinners" #right>
      <button class="btn btn-tertiary h-full w-3em justify-center p-0" :disabled="!canIncrease" @click="increase">
        <plus-icon size="1.5x" />
      </button>
    </template>
  </base-input>
</template>

<script>
import { PlusIcon, MinusIcon } from '@bit/vekenkaluste.veke-ui.icons'
import BaseInput from '@bit/vekenkaluste.veke-ui.input'

export default {
  name: 'NumberField',
  components: { BaseInput, PlusIcon, MinusIcon },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number],
      default: 1,
    },
    step: {
      type: Number,
      default: 1,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 999,
    },
    wrapperClass: {
      type: [Object, Array, String],
      required: false,
      default: '',
    },
    hideSpinners: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      val: this.modelValue,
    }
  },
  computed: {
    valueInRange() {
      return this.val >= this.min && this.val <= this.max
    },
    canDecrease() {
      return this.val - this.step >= this.min
    },
    canIncrease() {
      return this.val + this.step <= this.max
    },
  },
  methods: {
    updateModelValue() {
      this.$emit('update:modelValue', this.val)
    },
    onFocus() {
      this.val = ''
    },
    onBlur() {
      if (this.val === '') {
        this.val = this.modelValue
      }
      if (!this.valueInRange && this.val) {
        this.val = (!this.canDecrease) ? this.min : this.max
        this.updateModelValue()
      }
    },
    increase() {
      if (this.canIncrease) {
        if (this.val < this.min) {
          this.val = this.min
        } else {
          this.val += this.step
        }
        this.updateModelValue()
      }
    },
    decrease() {
      if (this.canDecrease) {
        if (this.val > this.max) {
          this.val = this.max
        } else {
          this.val -= this.step
        }
        this.updateModelValue()
      }
    },
  },
}
</script>

<style lang="scss">
.number-field input {
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;
}
</style>
